import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AlertService } from '../../../services/alert/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { WaitingService } from '../../../features/layout/waiting/waiting.service';
import { CampaignService, DiffFaceInfos, OutputGetDiffusionDetail } from '../../../features/campaigns/campaign.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../../../../environments/environment';
import { SpotsModule } from '../../../features/spots/spots.module';
import { WEATHER_PARAMS, WEATHER_PARAMS_ICONS } from '../../../features/weather/weather.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterParams, FilterResult } from '../../crud/repository.service';
import { MatCardModule } from '@angular/material/card';
import { PlayerComponent } from '../../../features/spots/player/player.component';
import { DateTime } from 'luxon';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-diffusion-detail-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        SpotsModule,
        MatTooltipModule,
        MatCardModule,
        MatPaginatorModule,
    ],
    templateUrl: './diffusion-detail-dialog.component.html',
    styleUrl: './diffusion-detail-dialog.component.scss'
})
export class DiffusionDetailDialogComponent implements OnInit {
    //#region Variables
    @Input() diffusionId: number = null;
    @Input() diffusionName: string = null;
    public isDiffLoading: boolean = false;
    /**
     * Détail de la diffusion sélectionnée
     */
    public diffusionDetail: OutputGetDiffusionDetail = null;
    public weatherParams: string[];
    public weatherParamsIcons: string[];
    public isFacesLoading: boolean = false;
    public facesInfos: DiffFaceInfos[] = [];
    public baseUrl: string = null;
    private readonly maxDayToDisplay = 100;
    public totalFaces: number = 0;
    public faceFilterParams: FilterParams;

    //#endregion Variables

    // MARK: CONSTRUCTOR
    constructor(
        private alert$: AlertService,
        private campaign$: CampaignService,
        private dialogRef: MatDialogRef<DiffusionDetailDialogComponent, any>,
        private dialog: MatDialog,
        private waiting$: WaitingService,
    ) {
        this.weatherParams = WEATHER_PARAMS;
        this.weatherParamsIcons = WEATHER_PARAMS_ICONS;
        this.baseUrl = environment.apiBaseUrl;
    }


    ngOnInit(): void {
        if (this.diffusionId == null) {
            this.alert$.show({
                message: "Erreur lors de la récupération de votre diffusion",
                duration: 1700
            });
        }

        this.getDiffDetail();


        //Init FacefilterParams
        this.faceFilterParams = new FilterParams();
        this.faceFilterParams.page = 0;
        this.faceFilterParams.pageSize = 20;

        this.getDiffFaces();




    }



    /**
     * Récupère les informations de la diffusion
     */
    private getDiffDetail() {
        this.isDiffLoading = true;

        const waitingId: string = this.waiting$.start();
        this.campaign$.getDiffusionDetail(this.diffusionId).subscribe({
            next: (outputDiffDetail: OutputGetDiffusionDetail) => {
                this.waiting$.end(waitingId);
                console.log(outputDiffDetail);

                this.diffusionDetail = outputDiffDetail;

                this.isDiffLoading = false;
            },
            error: (err: HttpErrorResponse) => {
                this.waiting$.end(waitingId);
                console.error("DiffusionDetailDialogComponent - GetDiffusionDetail() : ", err);

                this.alert$.show({
                    message: "Impossible de charger le détail de votre diffusion",
                    duration: 1700
                });

                this.isDiffLoading = false;
                this.dialogRef.close();

            }
        });
    }

    private getDiffFaces() {
        this.isFacesLoading = true;

        const waitingId: string = this.waiting$.start();


        this.campaign$.getFacesForDiffusion(this.diffusionId, this.faceFilterParams).subscribe({
            next: (result: FilterResult<DiffFaceInfos>) => {
                this.waiting$.end(waitingId);

                this.facesInfos = result.items;

                this.totalFaces = result.total;

                this.isFacesLoading = false;
            }, error: (err: HttpErrorResponse) => {
                this.waiting$.end(waitingId);

                console.error("DiffusionDetailDialogComponent - GetDiffFaces() : ", err);

                this.alert$.show({
                    message: "Erreur lors du chargement des faces de la diffusion",
                    duration: 1700
                });


                this.isFacesLoading = false;
            }
        })
    }

    public playScreenFile(storageId: string) {
        const playerDialogRef = this.dialog.open(PlayerComponent);

        playerDialogRef.componentInstance.fileStorageId = storageId;
        playerDialogRef.componentInstance.loadVideo();
    }

    /**
     * Calcule le temps avant que la diffusion démarre ou que la diffusion se termine
     *
     * @param diffusion Diffusion à retirer les jours
     * @returns Un texte à afficheir sur la diffusion
     */
    getDayDelta(diffusion: OutputGetDiffusionDetail): string {
        let test = DateTime.fromFormat(diffusion.diffStartDate, 'dd/MM/yyyy').toJSDate();
        test.setUTCHours(0, 0, 0, 0);
        test.setDate(test.getDate() + 1);

        const startDate = test;

        let endJs = DateTime.fromFormat(diffusion.diffEndDate, 'dd/MM/yyyy').toJSDate();
        endJs.setUTCHours(0, 0, 0, 0);
        endJs.setDate(endJs.getDate() + 1);

        const endDate = endJs;


        let today: Date = new Date();
        today.setUTCHours(0, 0, 0, 0);

        let deltaStartMs: number = today.valueOf() - startDate.valueOf();
        let returnString: string = '';
        if (typeof deltaStartMs === 'number') {
            const deltaStartDay: number = Math.abs(
                Math.trunc(deltaStartMs / 86400000)
            );
            if (deltaStartMs < 0 && deltaStartDay !== 0) {

                if (deltaStartDay === 1) {
                    returnString = 'Commence demain 🔥';
                } else if (deltaStartDay <= this.maxDayToDisplay) {
                    returnString = `Commence dans ${deltaStartDay} jours`;
                } else {
                    returnString = `Commence le ${diffusion.diffStartDate}`;
                }

                // console.log(returnString);
            } else {
                //Date passée 'Fin prévue dans ...'
                returnString = this.getEndDeltaDay(
                    endDate,
                    today,
                    returnString,
                    diffusion
                );
            }
        }

        return returnString;
    }

    private getEndDeltaDay(
        endDate: Date,
        today: Date,
        returnString: string,
        diffusion: OutputGetDiffusionDetail
    ): string {
        const deltaEndDays: number =
            (endDate.valueOf() - today.valueOf()) / 86400000
            ;

        const truncedDeltaEndD = Math.trunc(deltaEndDays);



        if (deltaEndDays >= 0) {
            switch (truncedDeltaEndD) {
                case 0:

                    returnString = `Fin prévue ce soir`;
                    break;
                case 1:
                    returnString = 'Fin prévue demain';
                    break;

                default:
                    if (truncedDeltaEndD <= this.maxDayToDisplay) {
                        returnString = `En cours, reste ${truncedDeltaEndD} jours`;
                    } else if (diffusion.isPermanent) {
                        returnString = 'En cours';
                    } else {
                        returnString = `En cours, termine le ${diffusion.diffEndDate}`;
                    }
                    break;
            }
        } else {

            if (truncedDeltaEndD === 0) {
                returnString = `Terminée hier`;
            } else {
                returnString = `Terminée depuis ${Math.abs(truncedDeltaEndD)} jour${truncedDeltaEndD === -1 ? '' : 's'
                    }`;
            }
        }

        return returnString;
    }

    getDeltaItemClass(diffusion: OutputGetDiffusionDetail): string {
        const dayDeltaText: string = this.getDayDelta(diffusion);

        const findTerm = (term) => {
            if (dayDeltaText.includes(term)) {
                return dayDeltaText;
            }
        };

        let classStr: string = 'deltaItem ';

        switch (dayDeltaText) {
            case findTerm('Commence demain'):
                classStr += 'verysoon';
                break;
            case findTerm('Commence dans'):
            case findTerm('Terminée'):
            case findTerm('Commence le'):
                classStr += 'soon';
                break;
            case findTerm('prévue demain'):
                classStr += 'endTomorrow';
                break;
            case findTerm('En cours'):
                classStr += 'current';
                break;
            case findTerm('prévue ce soir'):
                classStr += 'endNow';
                break;
            default:
                break;
        }

        return classStr;
    }

    public pageFaces(event: PageEvent) {
        this.faceFilterParams.page = event.pageIndex;
        this.faceFilterParams.pageSize = event.pageSize;

        this.getDiffFaces();
    }

    public getDisplayDate() {
        let start = (DateTime.fromFormat(this.diffusionDetail.diffStartDate, 'dd/MM/yyyy', { locale: 'fr' })).toFormat('ccc dd/MM/yyyy');

        start = start[0].toUpperCase() + start.substring(1).toLowerCase();

        let end = (DateTime.fromFormat(this.diffusionDetail.diffEndDate, 'dd/MM/yyyy', { locale: 'fr' })).toFormat('ccc dd/MM/yyyy');

        end = end[0].toUpperCase() + end.substring(1).toLowerCase();

        return `Du ${start} au ${end}`;
    };



}
